(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["astrovinch-portfolio-gallery"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('astrovinch-gallery')) return;
  Promise.all([import('@theme/component'), import('@theme/section-renderer')]).then(([{ Component }, { sectionRenderer }]) => {
    if (customElements.get('astrovinch-gallery')) return;
    class AstrovinchGallery extends Component {
      connectedCallback() {
        super.connectedCallback();
        if (this.controller) return;
        this.controller = new AbortController();
        this.version = (this.version || 0) + 1;
        this.grid = this.querySelector('.av-gallery-grid');
        this.navigation = this.querySelector('.av-gallery-categories');
        this.status = this.querySelector('[role="status"]');
        this.pagination = this.querySelector('.av-gallery-pages');
        this.nativePagination = this.querySelector('[data-native-pagination]');
        this.info = this.querySelector('[data-pagination-info]').dataset;
        this.originalCards ||= [...this.grid.children].map(card => card.cloneNode(true));
        this.base = new URL(location.href);
        this.base.hash = '';
        this.navigation.hidden = false;
        const signal = this.controller.signal;
        this.navigation.addEventListener('click', event => {
          const link = event.target.closest('[data-category]');
          if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          const params = new URLSearchParams({ categorie: link.dataset.category, portfolio: this.dataset.section, page: 1 });
          this.navigate(params);
        }, { signal });
        this.navigation.querySelectorAll('[data-category]').forEach(link => {
          link.href = `#${new URLSearchParams({ categorie: link.dataset.category, portfolio: this.dataset.section, page: 1 })}`;
        });
        this.pagination.querySelector('[data-previous]').addEventListener('click', () => this.changePage(-1), { signal });
        this.pagination.querySelector('[data-next]').addEventListener('click', () => this.changePage(1), { signal });
        window.addEventListener('hashchange', () => this.selectCategory(), { signal });
        this.selectCategory();
      }
      disconnectedCallback() {
        super.disconnectedCallback();
        this.version++;
        this.controller?.abort();
        this.fetchController?.abort();
        this.controller = null;
        this.cardsPromise = null;
      }
      updatedCallback() {
        super.updatedCallback();
        this.disconnectedCallback();
        this.originalCards = null;
        this.connectedCallback();
      }
      navigate(params) {
        const hash = `#${params}`;
        if (location.hash === hash) this.selectCategory();
        else location.hash = hash;
      }
      async collectCards(signal) {
        const pages = Number(this.info.pages);
        if (pages > 100) throw new Error('Portfolio collection limit exceeded');
        const pageCards = new Map([[Number(this.info.currentPage), this.originalCards.filter(card => card.hasAttribute('data-photograph'))]]);
        for (let page = 1; page <= pages; page++) {
          if (page === Number(this.info.currentPage)) continue;
          const url = new URL(this.base);
          url.searchParams.set(this.info.pageParam, page);
          const html = await sectionRenderer.getSectionHTML(this.dataset.section, false, url, signal);
          const template = document.createElement('template');
          template.innerHTML = html;
          const info = template.content.querySelector('[data-pagination-info]');
          if (!info || Number(info.dataset.currentPage) !== page || info.dataset.items !== this.info.items || info.dataset.pages !== this.info.pages) throw new Error('Incomplete portfolio response');
          pageCards.set(page, [...template.content.querySelectorAll('[data-photograph]')]);
        }
        const cards = new Map();
        for (let page = 1; page <= pages; page++) {
          for (const card of pageCards.get(page) || []) cards.set(card.dataset.photograph, card.cloneNode(true));
        }
        if (cards.size !== Number(this.info.items)) throw new Error('Portfolio changed during retrieval');
        const shuffled = [...cards.values()];
        for (let index = shuffled.length - 1; index > 0; index--) {
          const other = Math.floor(Math.random() * (index + 1));
          [shuffled[index], shuffled[other]] = [shuffled[other], shuffled[index]];
        }
        return shuffled;
      }
      restore() {
        this.grid.replaceChildren(...this.originalCards.map(card => card.cloneNode(true)));
        this.nativePagination.hidden = false;
        this.pagination.hidden = true;
        this.markCategory('');
        this.removeAttribute('data-initializing');
      }
      async selectCategory() {
        const version = ++this.version;
        const params = new URLSearchParams(location.hash.slice(1));
        const owner = params.get('portfolio');
        const ownsParams = !owner || owner === this.dataset.section;
        const requestedCategory = ownsParams ? params.get('categorie') || '' : '';
        const links = [...this.navigation.querySelectorAll('[data-category]')];
        const link = links.find(item => item.dataset.category === requestedCategory) || links[0];
        const category = link.dataset.category;
        this.setAttribute('aria-busy', 'true');
        this.status.textContent = category ? 'Chargement de la catégorie…' : 'Chargement du portfolio…';
        try {
          if (!this.cardsPromise) {
            this.fetchController = new AbortController();
            const collection = this.collectCards(AbortSignal.any([this.fetchController.signal, AbortSignal.timeout(30000)])).catch(error => {
              if (this.cardsPromise === collection) this.cardsPromise = null;
              throw error;
            });
            this.cardsPromise = collection;
          }
          const cards = await this.cardsPromise;
          if (version !== this.version || !this.isConnected) return;
          this.filtered = category ? cards.filter(card => card.dataset.categories.trim().split(/\s+/).includes(category)) : cards;
          this.category = category;
          this.pageCount = Math.max(1, Math.ceil(this.filtered.length / Number(this.dataset.pageSize)));
          const defaultPage = category ? 1 : Number(this.info.currentPage);
          const requestedPage = ownsParams && params.has('page') ? Math.floor(Number(params.get('page'))) || 1 : defaultPage;
          this.currentPage = Math.min(this.pageCount, Math.max(1, requestedPage));
          this.markCategory(category);
          this.renderCards(category ? link.textContent : 'Portfolio');
        } catch {
          if (version !== this.version || !this.isConnected) return;
          this.restore();
          this.status.textContent = 'Impossible de charger le portfolio complet. L’ordre initial et la pagination restent disponibles. Réessayez en choisissant une catégorie ou Tout.';
        } finally {
          if (version === this.version) this.removeAttribute('aria-busy');
        }
      }
      markCategory(category) {
        this.navigation.querySelectorAll('[data-category]').forEach(link => {
          if (link.dataset.category === category) link.setAttribute('aria-current', 'true');
          else link.removeAttribute('aria-current');
        });
      }
      changePage(offset) {
        this.focusStatus = true;
        this.navigate(new URLSearchParams({ categorie: this.category, portfolio: this.dataset.section, page: this.currentPage + offset }));
      }
      renderCards(label) {
        const size = Number(this.dataset.pageSize);
        const cards = this.filtered.slice((this.currentPage - 1) * size, this.currentPage * size).map(card => card.cloneNode(true));
        const eager = this.originalCards.some(card => card.querySelector('img')?.loading === 'eager');
        cards.forEach((card, index) => { const image = card.querySelector('img'); if (image) image.loading = eager && index === 0 ? 'eager' : 'lazy'; });
        if (!cards.length) {
          const empty = document.createElement('li');
          empty.textContent = this.category ? 'Aucune photographie dans cette catégorie pour le moment.' : 'Aucune photographie disponible pour le moment.';
          cards.push(empty);
        }
        if (this.grid.contains(document.activeElement)) this.focusStatus = true;
        this.grid.replaceChildren(...cards);
        this.nativePagination.hidden = true;
        this.pagination.hidden = this.pageCount <= 1;
        this.pagination.querySelector('[data-previous]').disabled = this.currentPage === 1;
        this.pagination.querySelector('[data-next]').disabled = this.currentPage === this.pageCount;
        this.pagination.querySelector('[data-page-label]').textContent = `Page ${this.currentPage} sur ${this.pageCount}`;
        this.status.textContent = `${label} : ${this.filtered.length} photographie${this.filtered.length === 1 ? '' : 's'}. Page ${this.currentPage} sur ${this.pageCount}.`;
        this.removeAttribute('data-initializing');
        if (this.focusStatus) { this.status.focus(); this.focusStatus = false; }
      }
    }
    customElements.define('astrovinch-gallery', AstrovinchGallery);
  }).catch(() => {
    document.querySelectorAll('astrovinch-gallery[data-initializing]').forEach(gallery => {
      gallery.querySelector('[role="status"]').textContent = '';
      gallery.removeAttribute('data-initializing');
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["astrovinch-text-carousel"] && !Shopify.designMode) return;
  try {
    
  // Section JavaScript is bundled by Shopify; dependencies use Horizon's existing import map.
  Promise.all([import('@theme/component'), import('@theme/scrolling'), import('@theme/utilities')]).then(
    ([{ Component }, { Scroller }, { prefersReducedMotion }]) => {
      if (customElements.get('astrovinch-text-carousel')) return;

      class TextCarousel extends Component {
        requiredRefs = ['scroller'];
        #slides = [];
        #copies = 0;
        #columns = 0;
        #current = 0;
        #step = 0;
        #scroll;
        #resize;
        #controller;
        #timer;
        #generation = 0;
        #moving = false;
        #dragController;

        get current() { return this.#current; }

        connectedCallback() {
          super.connectedCallback();
          this.#initialize();
        }

        updatedCallback() {
          super.updatedCallback();
          this.#initialize();
        }

        disconnectedCallback() {
          this.#cleanup();
          super.disconnectedCallback();
        }

        #cleanup() {
          this.#generation++;
          this.#moving = false;
          this.suspend();
          this.#controller?.abort();
          this.#dragController?.abort();
          this.#resize?.disconnect();
          this.#scroll?.destroy();
          this.#scroll = undefined;
          this.#removeCopies();
        }

        #removeCopies() {
          this.refs.scroller?.querySelectorAll('[data-carousel-copy]').forEach((slide) => slide.remove());
        }

        #initialize() {
          this.#cleanup();
          const scroller = this.refs.scroller;
          this.#slides = [...scroller.children];
          this.#current = Math.min(this.#current, Math.max(0, this.#slides.length - 1));
          this.#columns = 0;
          this.#controller = new AbortController();
          const { signal } = this.#controller;
          const scroll = new Scroller(scroller, {
            onScroll: () => {},
            onScrollEnd: () => { if (this.#scroll === scroll) this.#settle(); },
          });
          this.#scroll = scroll;
          scroller.addEventListener('pointerdown', (event) => this.#drag(event), { signal });
          this.addEventListener('mouseenter', () => this.suspend(), { signal });
          this.addEventListener('mouseleave', () => this.resume(), { signal });
          this.addEventListener('focusin', () => this.suspend(), { signal });
          this.addEventListener('focusout', () => queueMicrotask(() => this.resume()), { signal });
          document.addEventListener('visibilitychange', () => document.hidden ? this.suspend() : this.resume(), { signal });
          document.addEventListener('shopify:block:select', (event) => {
            if (!(event.target instanceof Element) || !this.contains(event.target)) return;
            const slide = event.target.closest('slideshow-slide');
            const index = this.#slides.indexOf(slide);
            if (index < 0) return;
            this.pause();
            this.select(index, undefined, { animate: false });
          }, { signal });
          const motion = matchMedia('(prefers-reduced-motion: reduce)');
          motion.addEventListener('change', () => this.resume(), { signal });
          this.#resize = new ResizeObserver(() => this.#layout());
          this.#resize.observe(scroller);
          this.#layout();
        }

        #layout() {
          if (!this.#slides.length) return;
          const scroller = this.refs.scroller;
          const columns = Number(getComputedStyle(this).getPropertyValue('--text-carousel-columns')) || 1;
          if (columns !== this.#columns) {
            this.#columns = columns;
            this.#removeCopies();
            this.#copies = this.#slides.length > columns ? Math.min(3, this.#slides.length) : 0;
            const copy = (slide) => {
              const clone = slide.cloneNode(true);
              clone.setAttribute('data-carousel-copy', '');
              for (const node of [clone, ...clone.querySelectorAll('*')]) {
                for (const attribute of [...node.attributes]) {
                  if (attribute.name === 'id' || attribute.name === 'ref' || attribute.name === 'slide-id' ||
                      attribute.name.startsWith('data-shopify-') || attribute.name.startsWith('on:')) {
                    node.removeAttribute(attribute.name);
                  }
                }
              }
              return clone;
            };
            if (this.#copies) {
              scroller.prepend(...this.#slides.slice(-this.#copies).map(copy));
              scroller.append(...this.#slides.slice(0, this.#copies).map(copy));
            } else {
              this.#current = 0;
            }
          }
          this.#step = this.#slides[0].getBoundingClientRect().width + parseFloat(getComputedStyle(scroller).gap || '0');
          this.#generation++;
          this.#moving = false;
          this.removeAttribute('transitioning');
          this.#goTo(this.#copies + this.#current, true);
          this.#update();
          this.resume();
        }

        #goTo(position, instant) {
          const direction = getComputedStyle(this).direction === 'rtl' ? -1 : 1;
          this.#scroll.to(direction * position * this.#step, { instant });
        }

        #drag(event) {
          if (event.pointerType !== 'mouse' || event.button !== 0 || this.#moving || !this.#copies ||
              event.target.closest('a, button, input, textarea, select')) return;
          event.preventDefault();
          this.#dragController?.abort();
          this.#dragController = new AbortController();
          const { signal } = this.#dragController;
          const scroller = this.refs.scroller;
          const start = event.clientX;
          const scroll = scroller.scrollLeft;
          this.#moving = true;
          this.setAttribute('transitioning', '');
          document.addEventListener('pointermove', (move) => {
            scroller.scrollLeft = scroll + start - move.clientX;
          }, { signal });
          const finish = () => {
            this.#dragController.abort();
            this.#moving = false;
            this.removeAttribute('transitioning');
            this.#settle();
          };
          document.addEventListener('pointerup', finish, { signal });
          document.addEventListener('pointercancel', finish, { signal });
        }

        #settle() {
          if (!this.isConnected || !this.#scroll || this.#moving || !this.#step || !this.#slides.length) return;
          const position = Math.round(Math.abs(this.refs.scroller.scrollLeft) / this.#step);
          this.#current = ((position - this.#copies) % this.#slides.length + this.#slides.length) % this.#slides.length;
          this.#goTo(this.#copies + this.#current, true);
          this.#update();
        }

        #update() {
          const scroller = this.refs.scroller;
          const start = Math.round(Math.abs(scroller.scrollLeft) / (this.#step || 1));
          [...scroller.children].forEach((slide, index) => {
            const visible = index >= start && index < start + this.#columns;
            slide.setAttribute('aria-hidden', String(!visible));
            slide.inert = !visible;
          });
          if (this.refs.current) this.refs.current.textContent = String(this.#current + 1);
          this.refs.dots?.forEach((dot, index) => dot.setAttribute('aria-selected', String(index === this.#current)));
          if (this.refs.slideshowControls) this.refs.slideshowControls.hidden = !this.#copies;
        }

        /** Select a logical review, keeping one-card movement across either end of the loop. */
        async select(input, event, { animate = true } = {}) {
          event?.preventDefault();
          if (this.#moving || !this.#copies) return;
          const requested = Number(input);
          if (!Number.isFinite(requested)) return;
          const count = this.#slides.length;
          const target = ((requested % count) + count) % count;
          const position = requested === count ? this.#copies + count : requested === -1 ? this.#copies - 1 : this.#copies + target;
          const generation = this.#generation;
          this.#moving = true;
          this.setAttribute('transitioning', '');
          this.#goTo(position, !animate || prefersReducedMotion());
          await this.#scroll.finished;
          if (!this.isConnected || generation !== this.#generation) return;
          this.#current = target;
          this.#goTo(this.#copies + target, true);
          this.#moving = false;
          this.removeAttribute('transitioning');
          this.#update();
        }

        next(event) { return this.select(this.#current + 1, event); }
        previous(event) { return this.select(this.#current - 1, event); }
        pause() { this.setAttribute('paused', ''); this.suspend(); }
        play() { this.removeAttribute('paused'); this.resume(); }
        suspend() { clearInterval(this.#timer); this.#timer = undefined; }
        resume() {
          this.suspend();
          const speed = Number(this.getAttribute('autoplay'));
          if (!this.#copies || !speed || this.hasAttribute('paused') || this.matches(':hover, :focus-within') ||
              document.hidden || prefersReducedMotion() || window.Shopify?.designMode) return;
          this.#timer = setInterval(() => this.next(), speed * 1000);
        }
      }

      customElements.define('astrovinch-text-carousel', TextCarousel);
    }
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
